import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config';
import { createAuth } from '../Helpers';

export const reducerName = 'winterDutyState';

export const getAllWinterDuties = createAsyncThunk(
    'winterDutyState/getAllWinterDuties',
    async (_, { getState, rejectWithValue }) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${config.server}/api/winterduties`,
                withCredentials: true,
                auth: createAuth(getState),
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

export const getAllVintermanToday = createAsyncThunk(
    'winterDutyState/getAllVintermanToday',
    async (_, { getState, rejectWithValue }) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${config.server}/api/vinterman/getAll`,
                withCredentials: true,
                auth: createAuth(getState),
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

const initialState = {
    error: null,
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    winterDuties: [],
};

const winterDutySlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // getAllWinterDuties
        builder
            .addCase(getAllWinterDuties.pending, (state) => {
                state.status = 'loading';
                state.error = null; 
            })
            .addCase(getAllWinterDuties.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.winterDuties = action.payload; 
            })
            .addCase(getAllWinterDuties.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred';
            });

        // getAllVintermanToday
        builder
            .addCase(getAllVintermanToday.pending, (state) => {
                state.status = 'loading';
                state.error = null; 
            })
            .addCase(getAllVintermanToday.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.winterDuties = action.payload; 
            })
            .addCase(getAllVintermanToday.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred'; 
            });
    },
});

export default winterDutySlice.reducer;